'use client';

import { useTranslations } from 'next-intl';

import { useState } from 'react';

import { actionButton } from '@/app/[locale]/(new)/(public)/projects/[slug]/_page.css';
import { Icons } from '@/app/_components/ui/icons';
import { useToast } from '@/app/_components/ui/use-toast';
import { DetailedProject } from '@/domain/project/types';
import generatePath from '@/lib/router/generate-path';
import Routes from '@/lib/router/routes';

import { useRouter } from '@/lib/translation/hooks';

import { favoriteProjectAction } from './action';

interface FavoriteButtonProps {
  project: Pick<DetailedProject, 'slug' | 'id' | 'isFavorite'>;
  isPageLocked: boolean;
}

export function FavoriteButton({ project, isPageLocked }: FavoriteButtonProps) {
  const t = useTranslations();
  const { toast } = useToast();
  const router = useRouter();
  const [isProjectFavorite, setIsProjectFavorite] = useState<boolean>(
    project.isFavorite,
  );

  const searchParams = new URLSearchParams({
    origin: generatePath(Routes.Project, { slug: project.slug }),
  });

  return (
    <button
      className={actionButton}
      type="button"
      disabled={isPageLocked}
      onClick={() => {
        favoriteProjectAction(project.id, isProjectFavorite).then((res) => {
          if (res.status === 'error') {
            toast({
              title: t('pages.project.header.addToFavorite.errorTitle'),
              description: t(
                'pages.project.header.addToFavorite.errorDescription',
              ),
              variant: 'destructive',
            });
          } else if (res.status === 'not-connected') {
            router.push(`${Routes.SignIn}?${searchParams.toString()}`);
          }

          setIsProjectFavorite(!isProjectFavorite);
        });
      }}
    >
      {isProjectFavorite ? <Icons.StarFilled /> : <Icons.Star />}
    </button>
  );
}
